import React,{useState,useEffect, useRef} from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import './MainLandingPage.css';
import logo from '../../botgurulogo.png';
import PrepGuruPage from './PrepGuruPage';
import MockGuruPage from './MockGuruPage';
import ResumeGuruPage from './ResumeGuruPage';
import JDGuruPage from './JDGuruPage';
import CareerGuruPage from './CareerGuruPage';
import Analytics from './Analytics';
import ProfileSection from './ProfileSection';
import './MyAccountModal.css';
import { useAuthContext } from '../Auth/AuthContext';
import config from "../../config.json";
import MyAccountModal from './MyAccountModal';
import { Brain, ChartNoAxesCombined, CircleX, FileText, FileUser, LogOut, Menu, Moon, Sun, Users, CircleUserRound,ClipboardCheck, ClipboardCheckIcon ,MessageSquareText } from 'lucide-react';
import useAuthService from '../../services/AuthService';
import SubscriptionsPage from './SubscriptionPage';
import AssessmentGuruPage from './AssessmentGuruPage';
import AssessmentDashboard from './Assessmentdashboard';
import FeedbackPage from './FeedbackPage';

function capitalizeFirstLetter(string) {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }


const MainLandingPage = () => {
    const location = useLocation();
    const [activeButton, setActiveButton] = useState(location.state?.activeButton || 'Account');
    // const [activeBot, setActiveBot] = useState(location.state?.activeBot || 'prep');
    const [activeView, setActiveView] = useState("Account"); // Track the current view (button or Account)
    const [previousView, setPreviousView] = useState(null); // To track the view before opening account details
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const[isLoading,setLoading]=useState(false);
    const {userObjId, profileData, setProfileData, userAnalytics, setUserAnalytics, onLogout,setJdData,setResumes,setPrepSessions,setMockSessions,portalTheme, setPortalTheme} = useAuthContext(); 
    const [logoutPopUp, setLogoutPopUp] = useState(false);
    const navigate=useNavigate("");
    const authService=useAuthService();

    const firstName = capitalizeFirstLetter(profileData.first_name);
    const lastName = capitalizeFirstLetter(profileData.last_name);
    const [assessmentDashboardData, setAssessmentDashboardData] = useState(null);
    const [dashboardLoading, setDashboardLoading] = useState(true);

    // console.log(profileData);

    useEffect(() => {
        const path = location.pathname.split('/')[2]; // Get the section after /landingPage/
        if (path) {
            // Map URL paths to view names
            const pathToViewMap = {
                'profile': 'Account',
                'analytics': 'Analytics',
                'prepbot': 'PrepGuru',
                'mockbot': 'MockGuru',
                'resumeexpert': 'ResumeGuru',
                'jdexpert': 'JDGuru',
                'assessmentbot': 'AssessmentGuru',
                'subscriptions': 'Subscriptions',
                'feedback':'Feedback'
            };
            const viewName = pathToViewMap[path.toLowerCase()] || 'Account';
            setActiveButton(viewName);
            setActiveView(viewName);
        } else if (location.state?.activeButton) {
            setActiveButton(location.state.activeButton);
            setActiveView(location.state.activeButton);
        } else {
            // Default to Account when no path specified
            setActiveButton('Account');
            setActiveView('Account');
        }
    }, [location]);

    // Add this useEffect to handle clicks outside the menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Get both menu and burger button elements
            const menuElement = document.querySelector('.landing-services');
            const burgerButton = document.querySelector('.burger-menu-btn');
            
            // Check if click is outside both menu and burger button
            if (menuElement && burgerButton && 
                !menuElement.contains(event.target) && 
                !burgerButton.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        // Add event listener to document
        document.addEventListener('click', handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []); // Empty dependency array since we want this to run once

    // Add this to close menu when a menu item is clicked
    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName);
        setActiveView(buttonName);
        setIsMenuOpen(false); // Close menu after selection
        const viewToPathMap = {
            'Account': 'profile',
            'Analytics': 'analytics',
            'PrepGuru': 'prepBot',
            'MockGuru': 'mockBot',
            'ResumeGuru': 'resumeExpert',
            'JDGuru': 'jdExpert',
            'AssessmentGuru': 'assessmentBot',
            'Subscriptions': 'subscriptions',
            'Feedback':'Feedback'
        };
        const route = viewToPathMap[buttonName] || 'profile';
        navigate(`/landingPage/${route}`, { replace: true });
    };

    const openAccountDetails = () => {
        setActiveView("Account");
        setActiveButton('Account');
        navigate('/landingPage/profile', { replace: true });

    };
    
    const openSubscriptions = () => {
        setActiveView("Subscriptions");
        setActiveButton('Subscriptions');
        navigate('/landingPage/subscriptions', { replace: true });
    };


    const handleLogout = async () => {
        try {
            const response = await authService.logout( { 
                credentials: 'include'
            });
    
            if (response && response.isAuthenticated === false) {
                setLogoutPopUp(false);
                localStorage.removeItem("userObjId");
                localStorage.removeItem("userRole");
                onLogout();
                navigate("/");
            } else {
                console.error("Logout failed:", response);
                
            }
        } catch (error) {
            console.error("Error during logout:", error);
        }
    };

    useEffect(() => {
        const fetchProfileDetails = async () => {
            try {
                setProfileData({})
                const response = await fetch(`${config.restAPI}/accounts/getUserProfile/`, {
                    method: "POST",
                    credentials:"include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ user_obj_id:userObjId }),
                });
    
                if (!response.ok) {
                    throw new Error("Failed to fetch profile details");
                }
    
                const data = await response.json();
                setProfileData(data.response);
            } catch (error) {
                console.error("Error fetching profile details:", error);
            }
        };
    
        fetchProfileDetails();
    }, [userObjId]);

    useEffect(() => {
        if (!userObjId) {
            return;
        }

            const fetchAnalyticsDetails = async () => {
                try {
                    setDashboardLoading(true);
                    setUserAnalytics({});
                    const response = await fetch(`${config.restAPI}/sessions/getUserAnalytics/`, {
                        method: "POST",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ user_obj_id: userObjId }),
                    });
                    if (!response.ok) throw new Error("Failed to fetch analytics");
                    const data = await response.json();
                    setUserAnalytics(data);
                } catch (error) {
                    console.error("Error fetching analytics:", error);
                } finally {
                    setDashboardLoading(false);
                }
            };
            fetchAnalyticsDetails();
        
    }, [userObjId]);
    
useEffect(() => {
    // Apply portal theme on mount
    const root = document.documentElement;
    const savedTheme = localStorage.getItem("portalTheme") || "light";
    root.setAttribute("theme", savedTheme);
    
    setPortalTheme(savedTheme);

    const toggleTheme = document.getElementById("checkbox");
    if (toggleTheme) {
        // Set checkbox state based on saved theme
        toggleTheme.checked = savedTheme === "light";
        
        const handleThemeChange = () => {
            if (toggleTheme.checked) {
                setPortalTheme("light");
            } else {
                setPortalTheme("dark");
            }
        };
        
        toggleTheme.addEventListener("click", handleThemeChange);
        return () => toggleTheme.removeEventListener("click", handleThemeChange);
    }
}, [setPortalTheme]);

    const menuRef = useRef(null);
    const toggleMenu = (e) => {
        e.stopPropagation(); // Prevent event from bubbling up
        setIsMenuOpen(!isMenuOpen);
    };
    useEffect(()=>{
        const handleClickOutside=(event)=>{
            if(menuRef.current && menuRef.current.contains(event.target)){
                setIsMenuOpen(false);
            }
        }
        if(isMenuOpen){
            document.addEventListener("mousedown", handleClickOutside)
        }else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
          };
    },[isMenuOpen]);


    return (
        <div className='main-landing-page'>
            <div className='left-landing-page'>
                <button className='burger-menu-btn' onClick={toggleMenu}>
                    <Menu className='burger-menu-btn-icon' />
                </button>
                <div className='logo-container'>
                    <img className='logo' 
                        src={portalTheme === "light" ? "/botGuruBlackLogo.svg" : logo} 
                        alt={logo} 
                        style={{ pointerEvents: 'none' }}>
                    </img>
                        <div className={`toggle-theme-container`}>
                            <input type='checkbox' id="checkbox" />
                            <label for="checkbox" className='toggle-theme-label'>
                                <span className='toggleBtn'></span>
                                <Sun className={`sun-icon`} />
                                <Moon className={`moon-icon`} />
                            </label>
                        </div>
                </div>
                <div className="profile-nav-card" onClick={() => handleButtonClick('Account')}>
                    <div className="profile-nav-avatar">
                        {profileData?.profile_image ? (
                            <img src={profileData.profile_image} alt="Profile" />
                        ) : (
                            <CircleUserRound className='profile-nav-icon' />
                        )}
                    </div>
                    <div className="profile-nav-info">
                        <span className="profile-nav-name">{firstName || 'User'} {lastName || ''}</span>
                        <span className="profile-nav-email">{'View Profile'}</span>
                    </div>
                </div>
                <div 
                    className={`landing-services ${isMenuOpen ? 'menu-open' : ''}`}
                    ref={menuRef}
                    onClick={(e) => e.stopPropagation()} // Prevent clicks inside menu from closing it
                >

                        {/* Mobile Profile Card */}
                        <div className="profile-nav-card-mobile" onClick={() => handleButtonClick('Account')}>
                            <div className="profile-nav-avatar">
                                {profileData?.profile_image ? (
                                    <img src={profileData.profile_image} alt="Profile" />
                                ) : (
                                    <CircleUserRound className='profile-nav-icon' />
                                )}
                            </div>
                            <div className="profile-nav-info">
                                {/* <span className="profile-nav-name">{firstName || 'User'} {lastName || ''}</span>  */}
                                <span className="profile-nav-email">{ 'View Profile'}</span>
                            </div>
                        </div>
                    
                    {/* <button
                        className={activeButton === 'Analytics' ? 'active' : ''}
                        onClick={() => handleButtonClick('Analytics')}
                    >
                       
                        <ChartNoAxesCombined className='navigation-logo'/>
                        Dashboard
                    </button> */}
                    {/* {profileData?.professional_status?.toLowerCase() === 'student' && ( */}
                    <button
                        className={activeButton === 'AssessmentGuru' ? 'active' : ''}
                        onClick={() => handleButtonClick('AssessmentGuru')}
                    >
                        <ClipboardCheckIcon className='navigation-logo' />
                            PrepAssessmentBot
                    </button>
                    {/* )} */}
                    {/* {profileData?.professional_status?.toLowerCase() === 'student' && (
                    <button
                        
                        // onClick={() => handleButtonClick('AssessmentGuru')}
                    >
                        <ClipboardCheckIcon className='navigation-logo' />
                            AssessmentBot
                    </button>
                    )} */}

                    {/* {profileData?.professional_status?.toLowerCase() === 'working' && (
                        <> */}
                    <button
                        className={activeButton === 'PrepGuru' ? 'active' : ''}
                        onClick={() => handleButtonClick('PrepGuru')}
                    >
                        {/* <img src="/prepguruicon.png" alt="Logo" /> */}
                        <Brain className='navigation-logo' />
                        PrepBot
                    </button>
                    <button
                        className={activeButton === 'MockGuru' ? 'active' : ''}
                        onClick={() => handleButtonClick('MockGuru')}
                    >
                        {/* <img src="/mockguruicon.png" alt="Logo" /> */}
                        <Users className='navigation-logo' />
                        MockBot
                    </button>
                    <button
                        className={activeButton === 'ResumeGuru' ? 'active' : ''}
                        onClick={() => handleButtonClick('ResumeGuru')}
                    >
                        {/* <img src="/JDguruicon.png" alt="Logo" /> */}
                        <FileUser className='navigation-logo' />
                        ResumeExpert
                    </button>
                    <button
                        className={activeButton === 'JDGuru' ? 'active' : ''}
                        onClick={() => handleButtonClick('JDGuru')}
                    >
                        {/* <img src="/JDguruicon.png" alt="Logo" /> */}
                        <FileText className='navigation-logo' />
                        JDExpert
                        </button>
                        {/* </>
                    )} */}
                </div>
                <div className='nav-footer'>
                    {/* Add this right before <div className='nav-footer'> */}
                    <button onClick={() => handleButtonClick('Feedback')}>
                        <MessageSquareText size={20} />
                        Feedback
                    </button>
                    <ProfileSection openAccountDetails={openAccountDetails} openSubscriptions={openSubscriptions} userName={ `${firstName} ${lastName}`} setLogoutPopUp={setLogoutPopUp}/>
                    <div className="version-info">
                        Version 1.0.0
                    </div>
                </div>
            </div>

            <div className="right-landing-page">
                {/* {activeView === 'Analytics' && (
                    !profileData?.professional_status || dashboardLoading ? (
                        <div className="ad-loading">
                        <div className="ad-spinner"></div>
                        <p>Loading dashboard...</p>
                        </div>
                    ) : profileData.professional_status.toLowerCase() === 'student' ? (
                        <AssessmentDashboard data={assessmentDashboardData} />
                    ) : (
                        <Analytics analyticsData={userAnalytics} />
                    )
                )} */}
                {activeView  === 'PrepGuru' && <PrepGuruPage ></PrepGuruPage>}
                {activeView  === 'MockGuru'  && <MockGuruPage></MockGuruPage>}
                {activeView ==='ResumeGuru'  && <ResumeGuruPage></ResumeGuruPage>}
                {activeView ==='JDGuru' && <JDGuruPage></JDGuruPage>}
                {activeView ==='CareerGuru' && <CareerGuruPage></CareerGuruPage>}
                {activeView === "Account" && <MyAccountModal handleSignOut={()=>setLogoutPopUp(true)}></MyAccountModal>}
                {activeView === 'Subscriptions' && <SubscriptionsPage />}
                {activeView === 'AssessmentGuru' &&  <AssessmentGuruPage />}
                {activeView === 'Feedback' && <FeedbackPage />}

            </div>
            {logoutPopUp ? <div className='logout-confirm-overlay' onClick={(e)=>{
                if(e.target.classList.contains("logout-confirm-overlay")){
                    setLogoutPopUp(false);
                }
            }}>
                <div className='logout-confirm-model'>
                    <div className='logout-cancel' onClick={()=>setLogoutPopUp(false)}>
                        <CircleX />
                    </div>
                    <div className='logout-model-header'>
                        <LogOut />
                        <div>
                            <h4>Confirm Logout</h4>
                            <span>Are you sure you want to log out? You'll need to sign in again to access your account.</span>
                        </div>
                    </div>
                    <div className='logout-buttons'>
                        <button className='logout-cancel-btn' onClick={()=>setLogoutPopUp(false)}>Cancel</button>
                        <button className='confirm-logout-btn' onClick={()=>handleLogout()}>Logout</button>
                    </div>
                </div>
            </div> : " "}
         </div>
    );
};

export default MainLandingPage;